import { render, staticRenderFns } from "./electronicLetterCmmmitOk.vue?vue&type=template&id=238a1aac&scoped=true&"
import script from "./electronicLetterCmmmitOk.vue?vue&type=script&lang=js&"
export * from "./electronicLetterCmmmitOk.vue?vue&type=script&lang=js&"
import style0 from "./electronicLetterCmmmitOk.vue?vue&type=style&index=0&id=238a1aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a1aac",
  null
  
)

export default component.exports